
import {
    get,
    post,
    del
} from '@/http/request'
import {
    HOST
} from '@/http/config'


// 新增资金支付
export function addPayMoney(params) {
    return post(`${HOST}pay-money/save`, params)
}
// 修改资金支付
export function updatePayMoney(params) {
    return post(`${HOST}pay-money/update`, params)
}
//资金支付列表
export function getPayMoney(params) {
    return get(`${HOST}pay-money/list/`, params)
}
//资金支付草稿箱列表
export function PayMoneyDraftlist(params) {
    return get(`${HOST}pay-money/draftlist`, params)
}
//资金支付详情
export function PayMoneyDetial(params) {
    return get(`${HOST}pay-money/get`, params)
}

// 删除资金支付
export function delPayMoney(params) {
    return del(`${HOST}pay-money/delete`, params)
}
//收款资料表
export function sysCollection(params) {
    return get(`${HOST}sys-collection/list`, params)
}






// WEBPACK FOOTER //
// ./src/views/FundPayment/api/api.js